/**
 * Calendar range picker and validation: 
 */

import { logger, dId } from "./utils.js";
import { easepick } from "@easepick/core";
import { RangePlugin } from "@easepick/range-plugin";
import { KbdPlugin } from "@easepick/kbd-plugin";
import { LockPlugin } from "@easepick/lock-plugin";
import { langDict } from "./dict.js";

declare const URL_BASE: string;
declare const LANG: string;
declare const LONGRENT: boolean;

let pickerFrom: any;
let tempDates = <Date[]>[];

function attach_datepicker() {

  let locale_lang = {one:'día', other:'días'};
  let time_zone = "es-ES";

  if (LANG == "ENG") {

   locale_lang =  {
      one:'day', other:'days',
    }
    
    time_zone = "en-GB";
  }


  logger("attach datepicker", "log");

  pickerFrom = new easepick.create({
    element: "#fecha_salida",
    
    css: [ URL_BASE + "css/calendar.css" ],
    inline: false,
    zIndex: 10,
    lang: time_zone,
    calendars: 2,
    grid: 2,

    plugins: [
      RangePlugin,
      KbdPlugin,
      LockPlugin
    ],
    LockPlugin: {
      minDate: new Date(),
      maxDate: new Date(new Date().setFullYear(new Date().getFullYear() + 1)),
    },
    RangePlugin: {
      elementEnd: "#fecha_vuelta",
      repick: true,
      tooltipNumber(num) {
        return num-1;
      },
      locale: locale_lang,
    }
  });

  pickerFrom.on("select", updatePrettyDates);
  pickerFrom.on("hide", pickerCleared);

  // pickerFrom.on("select", focusNextElement);
  // pickerFrom.on("preselect", setPickerEndDate);

  attach_date_listeners();

}

function setPickerEndDate() {

  if (LONGRENT) {
    logger("set end date - first time. TBD.", "log");
  }

}


function updatePrettyDates() {

  logger("updatePrettyDates", "log");

  let lg = "es-ES";

  if (LANG == "ENG") {
    lg = "en-GB";
  }
  let fromTarget = (<HTMLElement>dId("fecha_salida_pretty"));
  let toTarget = (<HTMLElement>dId("fecha_vuelta_pretty"));
 

  const fromDate = pickerFrom.getStartDate();
  const toDate = pickerFrom.getEndDate();

  const prettyFrom = fromDate.toLocaleDateString(lg, { weekday: 'short', day: 'numeric',  month: 'long'});
  const prettyTo = toDate.toLocaleDateString(lg, { weekday: 'short', day: 'numeric',  month: 'long'});
  
  fromTarget.innerHTML = prettyFrom;
  toTarget.innerHTML = prettyTo;

  showTrustedShop();

}

function focusNextElement() {
  logger("focusNextElement", "log");
  let nextTarget = (<HTMLElement>dId("hora_salida"));
  nextTarget.focus();

}


function set_datepicker_dates(from: Date, to: Date) {

  logger("set_datepicker_dates" + from + " - " + to, "log");
  pickerFrom.setStartDate(from);
  pickerFrom.setEndDate(to);
  updatePrettyDates();

}


function attach_date_listeners() {

  logger("attach date listeners", "log");

  (<HTMLElement>dId("fecha_salida_pretty") ).addEventListener("click", () => { 
    logger("Fecha Salida Clicked", "log");
  
    hideTrustedShop();

    // Remove end date if it's set:
    if (pickerFrom.getEndDate() != null) {
      logger("Clear calendar","log");
      tempDates = [pickerFrom.getStartDate(), pickerFrom.getEndDate()];
      pickerFrom.clear();
      (<HTMLElement>dId("fecha_salida_pretty") ).innerHTML = langDict[3];
      (<HTMLElement>dId("fecha_vuelta_pretty") ).innerHTML = langDict[3];
    }

    (<HTMLElement>dId("fecha_salida")).click();

  });

  (<HTMLElement>dId("fecha_vuelta_pretty") ).addEventListener("click", () => { 
    logger("Fecha Vuelta Clicked - reset", "log");
    (<HTMLElement>dId("fecha_vuelta")).click();
    hideTrustedShop();  

  });

} 

/** If user entered to modify dates, then decided not to */
function pickerCleared() {

  logger("restore pickers if null");

  if (tempDates.length == 2 
    && pickerFrom.getStartDate() == null && pickerFrom.getEndDate() == null){

    logger("can restore", "log");

    pickerFrom.setStartDate(tempDates[0]);
    pickerFrom.setEndDate(tempDates[1]);
    updatePrettyDates();
  }

}


function hideTrustedShop() {
  logger("hide TrustedShop", "log");

  try {
  (<HTMLElement>dId("trustbadge-container-98e3dadd90eb493088abdc5597a70810")).classList.add("hidden");
  (<HTMLElement>dId("cookiescript_badge")).classList.add("hidden");
  
  } catch (e) {
    logger("no trusted shop", "log");
  }

}

function showTrustedShop() {

  logger("show TrustedShop", "log");

  try {
  (<HTMLElement>dId("trustbadge-container-98e3dadd90eb493088abdc5597a70810")).classList.remove("hidden"); 
  (<HTMLElement>dId("cookiescript_badge")).classList.remove("hidden");
  } catch (e) {
    logger("no trusted shop", "log");
  }

}

export { attach_datepicker, set_datepicker_dates };